import {
  AppDataSync,
  InstancesStore,
} from '../Analytics/context/AnalyticsContext.types';
import { Clarity } from './Clarity';

export const getClarityInstances = (appDataSync: AppDataSync) => {
  const clarity = appDataSync?.clarity;
  const clarityInstances: InstancesStore = {};
  const defaultInstanceName = 'DEFAULT_CLARITY_INSTANCE';

  if (clarity?.enabled !== false) {
    if (clarity?.default) {
      const defaultInstance = new Clarity();

      clarityInstances[defaultInstanceName] = {
        mode: 'clarity',
        instance: defaultInstance,
      };
    }

    if (clarity?.configs) {
      clarity.configs.forEach(config => {
        if (!clarityInstances[config.name]) {
          const customInstance = new Clarity(config.clarityId);

          clarityInstances[config.name] = {
            mode: 'clarity',
            instance: customInstance,
          };
        }
      });
    }
  }

  return clarityInstances;
};
